<template>
    <div class="replies">
        <v-layout align-center class="">
<!--            <v-radio-group row v-model="replay.type" class="ml-4">-->
<!--                <v-radio-->
<!--                        label="Text"-->
<!--                        value="text"-->
<!--                ></v-radio>-->
<!--                <v-radio-->
<!--                        label="Blocks"-->
<!--                        value="blocks"-->
<!--                ></v-radio>-->
<!--            </v-radio-group>-->
            <h4 class="heading  font-weight-regular mb-3 user-intent">Bot  Replies With :</h4>
            <v-btn-toggle v-model="replay.type">
                <v-btn value="text"  round height="30">
                    Text
                </v-btn>
                <v-btn value="blocks"   height="30">
                    Blocks
                </v-btn>
            </v-btn-toggle>
        </v-layout>
        <v-autocomplete
                v-if="replay.type === 'blocks'"
                v-model="replay.blocks"
                :items="blocks"
                item-text="name"
                item-value="id"
                chips
                return-object
                outline
                solo
                multiple
        >
            <template v-slot:selection="data">
                <v-chip
                        :selected="data.selected"
                        close
                        @input="removeBlock(data.item)"
                >
                    <strong>{{ data.item.name }}</strong>&nbsp;
                </v-chip>
            </template>
        </v-autocomplete>
        <v-textarea
            v-model="replay.text"
            v-if="replay.type === 'text'"
            outline
        >

        </v-textarea>
    </div>

</template>

<script>
    import common from "../../utils/common"
    import _ from 'lodash'
    export default {
        name: "replays",
        props: {
            replay: {
                type: Object,
                default: ()=>{
                    return {}
                }
            },
            blocks: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data(){
            return {
            }
        },
        mounted() {
        },
        methods: {
            removeBlock(block){
                let index = this.replay.blocks.indexOf(block.id)
                this.replay.blocks.splice(index,1)
            }
        }
    }
</script>

<style>
    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0;
        margin-top: -10px;
    }
</style>